function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8006 1.08041L5.80257 5.95241L0.804566 1.08041C0.715269 0.99319 0.595394 0.944359 0.470566 0.944359C0.345739 0.944359 0.225864 0.99319 0.136566 1.08041C0.0933286 1.12278 0.0589787 1.17334 0.0355287 1.22915C0.0120787 1.28495 0 1.34488 0 1.40541C0 1.46595 0.0120787 1.52587 0.0355287 1.58168C0.0589787 1.63748 0.0933286 1.68805 0.136566 1.73041L5.45357 6.91441C5.54694 7.00543 5.67217 7.05636 5.80257 7.05636C5.93296 7.05636 6.05819 7.00543 6.15157 6.91441L11.4686 1.73141C11.5121 1.68902 11.5467 1.63833 11.5704 1.58233C11.594 1.52634 11.6062 1.46619 11.6062 1.40541C11.6062 1.34464 11.594 1.28448 11.5704 1.22849C11.5467 1.1725 11.5121 1.12181 11.4686 1.07941C11.3793 0.99219 11.2594 0.943359 11.1346 0.943359C11.0097 0.943359 10.8899 0.99219 10.8006 1.07941V1.08041Z",
  fill: "white"
});
function SvgArrowOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpenIcon);
export default __webpack_public_path__ + "static/media/arrow_open_icon.79834b6186236c4425b75f4bc807c758.svg";
export { ForwardRef as ReactComponent };